import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/user/pending.vue'
wx.createPage(MiniProgramPage)